import { ref, computed, type Ref } from 'vue'
import { defineStore } from 'pinia'
import * as Sentry from '@sentry/browser'
import * as API from '@/services/api/sync'
import type { Action } from '@/actions/Action'

export const useSyncStore = defineStore(
  'sync',
  () => {
    const dataToSync: Ref<Array<Action>> = ref([])

    const hasDataToSync = computed(() => dataToSync.value.length > 0)

    const syncAction = async (action: Action) => {
      const result = await API.syncAction(action)
      if (!result) {
        dataToSync.value.push(action)
        return false
      }
      return true
    }

    const syncData = async () => {
      if (!navigator.onLine) return false
      if (!hasDataToSync.value) return false

      let dataSynced = false

      for (let i = 0; i < dataToSync.value.length; i++) {
        try {
          const data = dataToSync.value[0]
          const result = await API.syncAction(data)

          if (result) {
            dataToSync.value.splice(i, 1)
            i--
            dataSynced = true
          }
        } catch (e) {
          console.error(e.message)
          Sentry.captureException(e)
        }
      }

      return dataSynced
    }

    return {
      dataToSync,
      hasDataToSync,
      syncAction,
      syncData,
    }
  },
  {
    persist: true,
  },
)
